import React from 'react'

import { Button } from '@driftt/dds'
import { H4, Div, P, ColorWay } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'


import './style.css'

const NoAccounts = ({ openCreateOrEditAccountSidebar }) => (
  <Div className="accounts-table-zero-state">
    <ColorWay className="no-accounts-icon" type="2"><Icon name="cw-document" /></ColorWay>
    <H4>Add your target accounts to Drift to start having more conversations!</H4>
    <P>Roll out the red carpet and create a direct line of communication between your accounts and their account owners.</P>
    <Div className="no-accounts-actions">
      <Button onClick={() => window.location.replace('/settings/salesforce/config')} >Sync from Salesforce</Button>
      <Button variant="secondary" onClick={() => openCreateOrEditAccountSidebar()}>Add an account</Button>
    </Div>
  </Div>
)

const NoSearch = ({ accounts }) => (
  <Div className="accounts-table-zero-state">
    <ColorWay className="no-accounts-icon" type="4"><Icon name="cw-empty-search" /></ColorWay>
    <H4>No results</H4>
    <P>Sorry, we couldn’t find any accounts that matched. Try another search!</P>
  </Div>
)

const AccountsTableZeroState = ({ accounts, openCreateOrEditAccountSidebar }) => (
  !!accounts.total  ?
    <NoSearch /> :
    <NoAccounts openCreateOrEditAccountSidebar={openCreateOrEditAccountSidebar} />
)

export default (props) => (
  (!props.accounts.results.length && !props.loading) ?
    <AccountsTableZeroState {...props} /> :
    null
)
